import { createContext } from 'mobx-keystone';

export const accountCtx = createContext<{ accountId: string }>({ accountId: '' });
